import { Controller } from "stimulus"

export default class extends Controller {
  form() {
    var $form = new Forms.Contacts('.contacts-index');
    $form.apply();
  }
}
